import React, { useState, useRef, useEffect } from "react";
import QuickSearch from "@foundit/quick-search/dist/QuickSearch";
import { MIDDLEWARE } from "../utils/utils";

interface IProps {
  middleware: string;
  userDetails: any;
  isClient: boolean;
  handleEventListener?:({action, payload,page}:{action:string, payload?: any,page:string})=>void;
  page:string;
}

const SearchBar: React.FC<IProps> = ({ middleware, userDetails, isClient, handleEventListener,page }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const toggleOpen = () => {
    if(handleEventListener){
      handleEventListener({action:"openSearch", payload:{}, page});
    }
    setOpen((prev) => !prev);
  };

  const handleClose = () =>{
    setOpen(false);
  }

  useEffect(() => {
    if(typeof window === "undefined") return;


    if (open) {
      // Hide page scrollbar when QuickSearch is open
      document.body.style.overflow = "hidden";

    } else {
      // Restore page scrollbar when QuickSearch is closed
      document.body.style.overflow = "unset";

    }

    return () => {
      // Cleanup: restore scrollbar and remove event listeners
      document.body.style.overflow = "unset";

    };
  }, [open]);

  return (
    <div ref={wrapperRef} className="rec_header_ls_option_search_wrapper">
      <div className="rec_header_ls_option_search" onClick={toggleOpen} >
        <span className="rec_header_ls_option_txt">Search Candidates</span>
        <div className="rec_header_ls_search_icon">
            <div className="RecHeaderSprite icons search" />
        </div>
      </div>

      {open && isClient && (
        <QuickSearch page={page} middleware={middleware || MIDDLEWARE} userDetails={userDetails} handleClose={handleClose} handleEventListener={handleEventListener} />
      )}
    </div>
  );
};

export default SearchBar;
